module.exports = { raw: '8.7.0' };



//////////////////
// WEBPACK FOOTER
// ./~/auth0-js/src/version.js
// module id = 114
// module chunks = 0